import { includes } from 'lodash';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    filteredById: {},
    loading: false,
    segments: {
        users: {}
    },
    sortOrder: []
});

// Segment look up looks like
// segments[segmentType][typeId] = [...documentIds]
const getSegments = (byId) => {
    const initialSegments = {
        users: {}
    };
    return Object.values(byId).reduce((segments, doc) => {
        const { userProfileId } = doc;

        if (!segments.users[userProfileId]) {
            segments.users[userProfileId] = [];
        }

        // This is for uniquenss.
        // We shouldn't need includes if we can guarantee
        // uniqueness from the server data. Right now
        // it is just a workaround due to bad data.
        // "Includes" will be slow for larger arrays
        // and should be remove if possible
        if (!includes(segments.users[userProfileId], doc._id)) {
            segments.users[userProfileId].push(doc._id);
        }
        return segments;
    }, initialSegments);
};

export default (state = getInitialState(), action) => {
    let newById;
    let reduced;
    let newFilteredById;
    switch (action.type) {
        case ACTIONS.GET_USER_COLLECTION_START:
        case ACTIONS.GET_MANY_USER_COLLECTIONS_START: {
            return {
                ...state,
                loading: true
            };
        }
        case ACTIONS.PREDICT_COMPLETED_USERCOLLECTIONS:
        case ACTIONS.GET_MANY_USER_COLLECTIONS: {
            newById = { ...state.byId };
            action.payload.userCollections.forEach((userCollection) => {
                newById[userCollection._id] = userCollection;
            });

            return {
                ...state,
                byId: newById,
                loading: false,
                segments: getSegments(newById)
            };
        }

        case ACTIONS.GET_USER_COLLECTION:
        case ACTIONS.PUT_USER_COLLECTION_SUCCESS:
        case ACTIONS.PUT_USER_COLLECTION_CONTENT_SUCCESS:
        case ACTIONS.POST_USER_COLLECTION_SUCCESS: {
            const { userCollection } = action.payload;
            newById = Object.assign({}, state.byId, {
                [userCollection._id]: userCollection
            });
            return Object.assign({}, state, {
                byId: newById,
                loading: false,
                segments: getSegments(newById)
            });
        }

        case ACTIONS.GET_FILTERED_USER_COLLECTIONS: {
            reduced = action.payload.userCollections.reduce((prev, userCollection) => {
                prev[userCollection._id] = userCollection;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced,
                loading: false
            };

            return {
                ...state,
                byId: newById,
                filteredById: reduced,
                loading: false,
                segments: getSegments(newById)
            };
        }

        case ACTIONS.POST_SEARCHED_USER_COLLECTIONS: {
            reduced = action.payload.userCollections.reduce((prev, userCollection) => {
                prev[userCollection._id] = userCollection;
                return prev;
            }, {});

            newFilteredById = {
                ...state.filteredById,
                ...reduced
            };

            return {
                ...state,
                filteredById: newFilteredById,
                sortOrder: action.payload.sortOrder,
                loading: false
            };
        }

        case ACTIONS.CLEAR_SEARCHED_USER_COLLECTIONS: {
            return {
                ...state,
                loading: false,
                filteredById: {}
            };
        }

        case ACTIONS.CLEAR_USER_COLLECTIONS: {
            return {
                ...state,
                loading: false,
                byId: {}
            };
        }

        case ACTIONS.DELETE_USER_COLLECTION_SUCCESS: {
            const { userCollectionId } = action.payload;

            newById = { ...state.byId };
            delete newById[userCollectionId];

            newFilteredById = { ...state.filteredById };
            delete newFilteredById[userCollectionId];

            return {
                ...state,
                byId: newById,
                loading: false,
                filteredById: newFilteredById
            };
        }

        default:
            return state;
    }
};
